<app-ark-container
  [future]="dataObservable"
  [loadingTemplate]="loading"
  [successTemplate]="success"
  [failureTemplate]="failure"
  [errorTemplate]="error"
  (onFailure)="handleFailure($event)"
  (onSuccess)="onDataResolved($event[0])"
>
</app-ark-container>
<ng-template #loading>
  <div class="section">
    <ul>
      <li *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </li>
    </ul>
  </div>
</ng-template>
<ng-template #failure>
  <div class="error-container">
    <div class="error-msg">
      <!-- <va-icon name="faInfoCircle" class="info-icon"></va-icon> -->
      <span class="error-text">{{ errorMsg }}</span>
    </div>
  </div>
</ng-template>
<ng-template #error>
  <div class="error-container">
    <div class="error-msg">
      <!-- <va-icon name="faInfoCircle" class="info-icon"></va-icon> -->
      <span class="error-text">{{ errorMsg }}</span>
    </div>
  </div>
</ng-template>
<ng-template #success>
  <div class="reporting-grid">
    <app-ant-grid-custom
      (paginationChange)="getNextPageData($event[0], $event[1])"
      (sortChange)="onSortChange($event[0])"
      (filterChange)="filterApplied($event[0], $event[1])"
      [(dataToUse)]="dataToUse"
    >
    </app-ant-grid-custom>
  </div>
</ng-template>
